import { render, staticRenderFns } from "./direct_expense.vue?vue&type=template&id=2a438a7c"
import script from "./direct_expense.vue?vue&type=script&lang=js"
export * from "./direct_expense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports